import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

// Uncomment to import all icons from other sub-libraries
// import { fab } from '@fortawesome/free-brands-svg-icons'

const SelectedIcons = [
  fas.faCheckSquare,
  fas.faCoffee,
  far.faCreditCard,
  fas.faHome,
  fas.faMoneyBill,
  fas.faPhone,
  fas.faPiggyBank,
  fas.faShoppingCart,
  fas.faSpinner,
  fas.faStickyNote,
  fas.faTag,
  fas.faTags,
]

export const initializeFontLibrary = () => {
  library.add(fas)
}

export const selectedIcons = SelectedIcons.map(i => i.iconName)

// Not recommended. Rendering nearly 1000 icons causes visible lag
export const allSolidIcons = Object.values(fas).map(i => i.iconName)
export const allRegularIcons = Object.values(far).map(i => i.iconName)
